<template>
  <el-popover
    class="popover"
    placement="bottom-end"
    width="255"
    trigger="click"
  >
    <div class="box">
      <div class="title">{{ $t("share_partners_know") }}</div>
      <p v-clipboard:copy="url" v-clipboard:success="copy">
        {{ $t("share_link") }}
      </p>
      <div class="content">
        <input
          ref="input"
          type="text"
          :value="url"
          readonly
          v-clipboard:copy="url"
          v-clipboard:success="copy"
          @click="iptClick('url')"
        />
        <button
          @click="iptClick('copy')"
          v-clipboard:copy="url"
          v-clipboard:success="copy"
        >
          {{ $t("copy") }}
        </button>
        <button
          @click="
            choose();
            iptClick('select');
          "
        >
          {{ $t("selects") }}
        </button>
      </div>
      <div :class="['tip', show ? 'tip-show' : '']">
        <i class="iconfont iconfuzhidao1"></i>
        {{ $t("copy_clipboard") }}
      </div>
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
import {
  share,
  pickConversation,
  chooseConversationByCorpId,
  isYach,
  showToast,
} from "@/utils/ding";
import { okrMessageShare } from "@/constants/api/DATA_API";
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    obj_type: {
      type: String,
      default: "",
    },
    obj_id: {
      type: Number,
      default: 0,
    },
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      timer: null,
      sensorList: {
        url: "281",
        copy: "282",
        select: "283",
      },
    };
  },
  methods: {
    copy(e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      // this.timer ? clearTimeout(this.timer) : null;
      this.show = true;
      this.$refs.input.focus();
      this.$refs.input.selectionStart = 0;
      this.$refs.input.selectionEnd = this.url.length;
      this.timer = setTimeout(() => {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        // this.timer ? clearTimeout(this.timer) : null;
        this.show = false;
      }, 2000);
    },
    choose() {
      if (isYach) {
        chooseConversationByCorpId((res) => {
          const chat_id = {};
          for (const item of res) {
            const lowKey = item.chatId.toLowerCase();
            chat_id[lowKey] = item.type;
          }
          // let chat_id = isYach ? res.chatId : res.cid;
          okrMessageShare({
            msg_type: "chat",
            obj_type: this.obj_type,
            obj_id: `${this.obj_id}`,
            chat_id,
            url: this.url,
          }).then((data) => {
            showToast(this.$t("shared_successfully"), "success");
          });
        });
      } else {
        pickConversation((res) => {
          // console.log(res);
          // messageChat({
          //   chat_id: res.cid,
          //   note_id: this.baseData.id,
          //   url: this.url
          // }).then(data => {
          //   showToast(this.$t("shared_successfully"), "success");
          // });
          const chat_id = res.cid;
          okrMessageShare({
            msg_type: "chat",
            obj_type: this.obj_type,
            obj_id: `${this.obj_id}`,
            chat_id,
            url: this.url,
          }).then((data) => {
            showToast(this.$t("shared_successfully"), "success");
          });
        });
      }
      // share(this.url, "我是title", "我是content");
    },
    iptClick(type) {
      if (this.pageName) {
        window.sensorsData &&
          window.sensorsData.track("Click_Muse_Element", {
            pageName: this.pageName,
            $element_name: this.sensorList[type],
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  .title {
    font-size: 14px;
    color: #191e24;
    letter-spacing: 0.22px;
    font-weight: 600;
  }
  p {
    font-size: 13px;
    color: #191e24;
    letter-spacing: 0.21px;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    align-items: center;
    input {
      padding-left: 5px;
      border: 1px solid #d8d8d8;
      border-radius: 2px;
      height: 26px;
      width: 150px;
      box-sizing: border-box;
      font-size: 13px;
      color: #191e24;
      letter-spacing: 0.21px;
    }
    button {
      cursor: pointer;
      background: #eeeeee;
      border: none;
      border-radius: 2px;
      margin-left: 8px;
      font-size: 13px;
      color: #191e24;
      letter-spacing: 0.21px;
      width: 50px;
      height: 26px;
      &:hover {
        transition: all 0.3s;
        background: #ecedf0;
      }
      &:active {
        background: #deebff;
        color: #0052cc;
      }
    }
  }
  .tip {
    font-size: 13px;
    color: #191e24;
    letter-spacing: 0.21px;
    display: flex;
    align-items: center;
    padding-top: 8px;
    opacity: 0;
    margin-top: 0px;
    max-height: 0px;
    transition: opacity 600ms, margin-top 600ms, max-height 400ms,
      -webkit-transform 200ms;
    i {
      color: #326fef;
    }
  }
  .tip.tip-show {
    margin-top: 10px;
    max-height: 70px;
    opacity: 1;
  }
}
</style>
